import React, { useState, useEffect, useRef } from 'react';

const MediaHero = ({ backdrops = [], children }) => {
  const [visibleIndex, setVisibleIndex] = useState(0);
  const [fadeState, setFadeState] = useState("visible"); // "visible", "fading-out", "fading-in"
  const timerRef = useRef(null);

  // Handle backdrop transitions
  useEffect(() => {
    // Clear any existing timers when component unmounts or deps change
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  // Backdrop cycle
  useEffect(() => {
    if (backdrops.length <= 1) return; // No need to cycle with only one image
    
    const startCycle = () => {
      // Start the cycle after initial display
      timerRef.current = setTimeout(() => {
        // Start fade-out
        setFadeState("fading-out");
        
        // After fade-out, update the visible index and start fade-in
        timerRef.current = setTimeout(() => {
          const nextIndex = (visibleIndex + 1) % backdrops.length;
          setVisibleIndex(nextIndex);
          setFadeState("fading-in");
          
          // After fade-in completes, set state back to visible
          timerRef.current = setTimeout(() => {
            setFadeState("visible");
            
            // Schedule the next cycle
            startCycle();
          }, 1000); // Fade-in duration
        }, 1000); // Fade-out duration
      }, 5000); // Display duration
    };
    
    startCycle();
    
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [backdrops, visibleIndex]);

  // Style for the backdrop based on fade state
  const getBackdropStyle = () => {
    if (!backdrops.length) return {};
    
    const opacity = fadeState === "fading-out" ? 0 : 1;
    
    return {
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), 
                         url(${backdrops[visibleIndex]})`,
      opacity: opacity,
      transition: "opacity 1s ease-in-out"
    };
  };

  return (
    <div className="hero">
      <div 
        className="hero-backdrop" 
        style={getBackdropStyle()}
      ></div>
      {children}
    </div>
  );
};

export default MediaHero;